import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '~/lib/request';

function useBalance() {
  const result = useQuery({
    queryKey: ['balance'],
    queryFn: () =>
      subscriptionApi
        .get('api/balance/get_balance')
        .json<{ balance: number }>()
        .then(({ balance }) => balance),
  });

  return result;
}

export default useBalance;
